import { FaqAccordion } from "@cinch-nx/landing-ui-shared";
export var storyblokComponents = {
    FaqSection: FaqAccordion
};
